import WordBankSelectService from './Service'
import wordBankSelectReducer from './store/Reducer'
import React, { useReducer, useMemo, useRef } from 'react'
import { IProps } from './Interface'
import { Direction, IWordBank, WordBankCategory } from 'types'
import { wordBankSelectInitialState } from './store/State'
import { Corner } from 'components/balloon'

const wordBankSelectContext = {
  state: {
    ...wordBankSelectInitialState,
    subTypes: [] as string[],
    isTalentTag: false,
    navButtonTitle: 'Next',
    wordBanks: [] as IWordBank[],
    balloonCorner: Corner.MiddleRight,
    ref: null as React.RefObject<HTMLElement>
  }
}

export type WordBankSelectContext = typeof wordBankSelectContext

export const WordBankSelectContextProvider = React.createContext<WordBankSelectContext>(wordBankSelectContext)

const Provider: React.FC<IProps> = ({ children, wordBanks = [], category }) => {
  const [state] = useReducer(wordBankSelectReducer, wordBankSelectInitialState)
  const subTypes = WordBankSelectService.getSubTypes(wordBanks)
  const balloonCorner = state.direction === Direction.Right ? Corner.MiddleRight : Corner.MiddleLeft
  const navButtonTitle = state.direction === Direction.Right ? 'Next' : 'Back'
  const isTalentTag = category === WordBankCategory.TalentTags
  const ref = useRef(null)

  const contextValue = useMemo(
    () => ({
      ...wordBankSelectContext,
      state: {
        ...state,
        ref,
        subTypes,
        isTalentTag,
        wordBanks,
        balloonCorner,
        navButtonTitle
      }
    }),
    [state, wordBanks]
  )

  return useMemo(
    () => (
      <WordBankSelectContextProvider.Provider value={contextValue}>{children}</WordBankSelectContextProvider.Provider>
    ),
    [children, contextValue]
  )
}

export default Provider
